import { render, staticRenderFns } from "./SidebarEvents.vue?vue&type=template&id=581634f4&"
import script from "./SidebarEvents.vue?vue&type=script&lang=js&"
export * from "./SidebarEvents.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports